import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import Images from "../../Images";

const NetworkStats = ({ networkData }) => {
  const [total, setTotal] = useState(0);
  const [networkTotal, setNetworkTotal] = useState(0);

  useEffect(() => {
    const calculateTotals = () => {
      const allTotal = networkData.reduce(
        (sum, item) => sum + item.occurance,
        0
      );
      const networkOnlyTotal = networkData.reduce(
        (sum, item) => (item.network ? sum + item.occurance : sum),
        0
      );

      setTotal(allTotal);
      setNetworkTotal(networkOnlyTotal);
    };
    calculateTotals();
  }, [networkData]);

  const networkInfo = {
    MTN: {
      logo: Images.mtn_logo,
      color: "bg-yellow-400",
      textColor: "text-yellow-700",
      source: "Network Provider",
    },
    AT: {
      logo: Images.at_logo,
      color: "bg-blue-400",
      textColor: "text-blue-700",
      source: "Network Provider",
    },
    VDF: {
      logo: Images.telecel_logo,
      color: "bg-red-400",
      textColor: "text-red-700",
      source: "Network Provider",
    },
    null: {
      logo: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          className="w-full h-full text-gray-600"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M20 7h-3m3 0v3m0-3l-3 3M4 7h3m-3 0v3m0-3l3 3M20 17h-3m3 0v-3m0 3l-3-3M4 17h3m-3 0v-3m0 3l3-3"
          />
          <circle
            cx="12"
            cy="12"
            r="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      color: "bg-gray-400",
      textColor: "text-gray-700",
      source: "External Source",
    },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const cardVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    },
  };

  return (
    <div className="p-6">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-6 text-xl font-bold text-gray-800"
      >
        Network Distribution
      </motion.h2>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4"
      >
        {networkData.map((item, index) => {
          const network = item.network || "null";
          // Calculate percentage based on appropriate total
          const percentage = (
            (item.occurance / (network === "null" ? total : networkTotal)) *
            100
          ).toFixed(1);

          return (
            <motion.div
              key={network}
              variants={cardVariants}
              whileHover={{ scale: 1.05 }}
              className="overflow-hidden relative p-6 bg-white rounded-xl shadow-lg"
            >
              <div
                className={`absolute top-0 right-0 w-24 h-24 -mr-8 -mt-8 rounded-full opacity-10 ${networkInfo[network].color}`}
              />

              <div className="flex items-center mb-4">
                {typeof networkInfo[network].logo === "string" ? (
                  <motion.img
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.2 }}
                    src={networkInfo[network].logo}
                    alt={network}
                    className="object-contain mr-4 w-12 h-12 rounded-lg shadow-sm"
                  />
                ) : (
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.2 }}
                    className="mr-4 w-12 h-12"
                  >
                    {networkInfo[network].logo}
                  </motion.div>
                )}
                <div>
                  <h3 className="font-semibold text-gray-800 text-md">
                    {network === "null" ? "External Data" : (network === "MTN" ? "MTN" : network === "AT" ? "AT" : network === "VDF" ? "Telecel" : network)}
                  </h3>
                  {/* <div className="flex items-center">
                    <p className={`text-sm ${networkInfo[network].textColor}`}>
                      {networkInfo[network].source}
                    </p>
                  </div> */}
                </div>
              </div>

              <div className="mt-4">
                <div className="flex justify-between items-end">
                  <div>
                    <p className="text-3xl font-bold text-gray-800">
                      {item.occurance.toLocaleString()}
                    </p>
                    <p className="text-sm text-gray-500">
                      {network === "null" ? "total subscribers" : "subscribers"}
                    </p>
                  </div>
                  {network !== "null" && (
                    <div
                      className={`text-xs font-semibold ${networkInfo[network].textColor}`}
                    >
                      {percentage}%
                    </div>
                  )}
                </div>

                {network !== "null" && (
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${percentage}%` }}
                    transition={{ duration: 1, delay: 0.5 }}
                    className={`h-2 mt-2 rounded-full ${networkInfo[network].color}`}
                  />
                )}
              </div>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  );
};

export default NetworkStats;
